import { Context } from 'types/GlobalUserEvents'

/**
 * Get context of how something was opened,
 * and remove from query params.
 */
export const getContext = (searchParams: URLSearchParams): Context | null => {
  const context = searchParams.get('ref')?.toUpperCase()

  // remove context from search params
  searchParams.delete('ref')

  // update the URL without reloading the page
  const newUrl =
    window.location.pathname +
    (searchParams.toString() ? `?${searchParams.toString()}` : '')

  window.history.replaceState({}, '', newUrl)

  // validate context
  if (!context || !(Object.values(Context) as string[]).includes(context)) {
    return null
  }

  return context as Context
}
